<template>
    <div v-if="props.plan.winckPlanAddon" class="subscription-usps">
        <flex-container
            :gap="Size.xs"
            align-items="center"
        >
            <svg-icon
                :icon="CircleCheckIcon"
                :size="IconSize.xs"
                :color="'orange-500'"
                is-custom-icon
            />
            <template v-if="props.plan.winckPlanAddon.contacts === null">
                <text-decorator
                    :size="FontSize.sm"
                    weight="medium"
                >
                    Onbeperkt contacten
                </text-decorator>
            </template>
            <template v-else>
                <text-decorator
                    :size="FontSize.sm"
                    weight="bold"
                >
                    {{ formatNumber(props.plan.winckPlanAddon.contacts) }}
                </text-decorator>
                <text-decorator
                    :size="FontSize.sm"
                    weight="medium"
                >
                    Contacten
                </text-decorator>
            </template>
        </flex-container>

        <flex-container
            :gap="Size.xs"
            align-items="center"
        >
            <svg-icon
                :icon="CircleCheckIcon"
                :size="IconSize.xs"
                :color="'orange-500'"
                is-custom-icon
            />
            <text-decorator
                :size="FontSize.sm"
                weight="medium"
            >
                Standaard Flows
            </text-decorator>
        </flex-container>

        <flex-container
            :gap="Size.xs"
            align-items="center"
        >
            <template v-if="props.plan.winckPlanAddon.premiumFlows > 0">
                <svg-icon
                    :icon="CircleCheckIcon"
                    :size="IconSize.xs"
                    :color="'orange-500'"
                    is-custom-icon
                />
                <text-decorator
                    :size="FontSize.sm"
                    weight="bold"
                >
                    {{ formatNumber(props.plan.winckPlanAddon.premiumFlows) }}
                </text-decorator>
                <text-decorator
                    :size="FontSize.sm"
                    weight="medium"
                >
                    Premium flows
                </text-decorator>
                <svg-icon
                    :icon="StarIcon"
                    :size="IconSize.xs"
                    is-custom-icon
                />
            </template>
            <template v-else>
                <svg-icon
                    :icon="CircleCheckIcon"
                    :size="IconSize.xs"
                    :color="'gray-300'"
                    is-custom-icon
                />
                <text-decorator
                    :size="FontSize.sm"
                    :color="'gray-300'"
                    weight="medium"
                >
                    Premium flows
                </text-decorator>
                <svg-icon
                    :color="'gray-300'"
                    :icon="StarIcon"
                    :size="IconSize.xs"
                    is-custom-icon
                />
            </template>
        </flex-container>

        <flex-container
            :gap="Size.xs"
            align-items="center"
        >
            <svg-icon
                :icon="CircleCheckIcon"
                :size="IconSize.xs"
                :color="'orange-500'"
                is-custom-icon
            />
            <text-decorator
                :size="FontSize.sm"
                weight="bold"
            >
                {{ formatNumber(props.plan.winckPlanAddon.brands) }}
            </text-decorator>
            <text-decorator
                :size="FontSize.sm"
                weight="medium"
            >
                {{ props.plan.winckPlanAddon.brands > 1 ? 'Merken' : 'Merk' }}
            </text-decorator>
        </flex-container>

        <flex-container
            :gap="Size.xs"
            align-items="center"
        >
            <svg-icon
                :icon="CircleCheckIcon"
                :size="IconSize.xs"
                :color="'orange-500'"
                is-custom-icon
            />
            <text-decorator
                :size="FontSize.sm"
                weight="bold"
            >
                {{ formatNumber(props.plan.winckPlanAddon.users) }}
            </text-decorator>
            <text-decorator
                :size="FontSize.sm"
                weight="medium"
            >
                Gebruikers
            </text-decorator>
        </flex-container>

        <flex-container
            :gap="Size.xs"
            align-items="center"
        >
            <svg-icon
                :icon="CircleCheckIcon"
                :size="IconSize.xs"
                :color="'orange-500'"
                is-custom-icon
            />
            <text-decorator
                :size="FontSize.sm"
                weight="medium"
            >
                Onbeperkt vestigingen
            </text-decorator>
        </flex-container>

        <flex-container
            :gap="Size.xs"
            align-items="center"
        >
            <svg-icon
                :icon="CircleCheckIcon"
                :size="IconSize.xs"
                :color="'orange-500'"
                is-custom-icon
            />
            <text-decorator
                :size="FontSize.sm"
                weight="medium"
            >
                E-mail support
            </text-decorator>
        </flex-container>

        <flex-container
            :gap="Size.xs"
            align-items="center"
        >
            <svg-icon
                :icon="CircleCheckIcon"
                :size="IconSize.xs"
                :color="props.plan.winckPlanAddon.phoneSupport ? 'orange-500' : 'gray-300'"
                is-custom-icon
            />
            <text-decorator
                :color="props.plan.winckPlanAddon.phoneSupport ? 'inherit' : 'gray-300'"
                :size="FontSize.sm"
                weight="medium"
            >
                Telefonisch support
            </text-decorator>
        </flex-container>
    </div>
</template>

<script setup lang="ts">
    import CircleCheckIcon from '@keyvue/one-awesome-icons/icons/regular/circle-check.svg?component';
    import StarIcon from '@keyvue/one-awesome-icons/icons/regular/star.svg?component';
    import { FontSize, IconSize, Size } from '@keyvue/one-ui';
    import type { Plan } from '@keyvue/one-api-client';
    import { formatNumber } from '@/shared/utils/number';

    const props = defineProps<{
        plan: Plan
    }>();
</script>

<style scoped lang="scss">
    .subscription-usps {
        display: flex;
        flex-direction: column;
        padding: size(md);
        gap: size(sm);
    }
</style>
